import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0f888f',
    },
  },
});

export type Theme = typeof theme;

export default theme;
